import classNames from 'classnames';
import Form from 'next/form';
import { ChangeEvent, FC, useActionState, useEffect, useState } from 'react';

import { resetPasswordAction } from '@/features/auth';
import { Input } from '@/shared/ui';
import { MODAL_TYPES } from '@/widgets/modals/config/constants';
import { useModalStore } from '@/widgets/modals/model/store';

import styles from './resetPassword.module.scss';

interface ResetPasswordProps {
  className?: string;
  value: {
    token: string;
    email: string;
  };
}

const initialState = {
  message: '',
  success: false,
  fieldErrors: {
    email: '',
    token: '',
    password: '',
    password_confirmation: '',
  },
};

const ResetPassword: FC<ResetPasswordProps> = (props) => {
  const { value, className } = props;
  const { openModal } = useModalStore();
  const [state, formAction, isPending] = useActionState(
    resetPasswordAction,
    initialState,
  );
  const [form, setForm] = useState({
    password: '',
    password_confirmation: '',
  });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (state.success) {
      openModal(MODAL_TYPES.passwordChanged);
    }
  }, [state, openModal]);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.container__content}>
        <div className={styles.container__titleBlock}>
          <p className={styles.container__title}>Сбросить пароль</p>
        </div>
        <div className={styles.container__textBlock}>
          <p className={styles.container__text}>
            Придумайте новый пароль и подтвердите его
          </p>
        </div>
        <Form action={formAction} className={styles.container__form}>
          <div className={styles.container__form_item}>
            <Input
              buttonType="button"
              className={styles.container__form_input}
              error={state?.fieldErrors?.password}
              label="Пароль"
              name="password"
              rightIcon={showPassword ? 'eyeOpen' : 'eyeClosed'}
              type={showPassword ? 'text' : 'password'}
              value={form.password}
              onButtonClick={toggleShowPassword}
              onChange={handleInputChange}
            />
            <Input
              buttonType="button"
              className={styles.container__form_input}
              error={state?.fieldErrors?.password_confirmation}
              label="Пароль"
              name="password_confirmation"
              rightIcon={showPassword ? 'eyeOpen' : 'eyeClosed'}
              type={showPassword ? 'text' : 'password'}
              value={form.password_confirmation}
              onButtonClick={toggleShowPassword}
              onChange={handleInputChange}
            />
            <input name="email" type="hidden" value={value.email} />
            <input name="token" type="hidden" value={value.token} />
          </div>
          <div className={styles.container__form_bottom}>
            <button
              className={classNames('button button--confirm-white')}
              disabled={isPending}
            >
              Продолжить
            </button>
          </div>
        </Form>
        {state.message && (
          <p className={styles.container__error}>{state.message}</p>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
